import React, { useState, useEffect } from "react";

import { OverridableComponent } from "@material-ui/core/OverridableComponent";
import { Chip, SvgIconTypeMap, Button, withStyles } from "@material-ui/core";
import axios from "axios";
import { useRecoilState } from "recoil";
import { settings, locale, getHeaders } from "../../settings";
import ContentWrapper from "../../components/ContentWrapper";
import MainHeader from "../../components/MainHeader";
import MainTable from "../../components/MainTable";
import TitleHeader from "../../components/TitleHeader";
import DividerWrapper from "../../components/DividerWrapper";
import EditButton from "../../components/Buttons/EditButton";
import AddButton from "../../components/Buttons/AddButton";
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import PowerSettingsNew from '@material-ui/icons/PowerSettingsNew';

const ConfirmButton = withStyles(() => ({
  root: {
    color: "#fff",
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
    minWidth: "0 !important",
    padding: "8px 10px !important",
  },
}))(Button);

const CancelButton = withStyles(() => ({
  root: {
    color: "#fff",
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700],
    },
    minWidth: "0 !important",
    padding: "8px 10px !important",
  },
}))(Button);



import StoreAdd from "./StoreAdd";
import StoreEdit from "./StoreEdit";

import {
  confirmationDialogState,
  dialogState,
  loadingOverlayState,
  snackBarState,
  handleErrorState,
} from "../../GlobalAtoms";

const Store: React.FC<{
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
}> = () => {
  // States
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<any>([]);
  const [editDialogStatus, setEditDialogStatus] = useState(false);
  const [editDialogData, setEditDialogData] = useState({});
  const [editKey, setEditKey] = useState<number | null>(null);

  // Recoil
  const [dialog, setDialogState] = useRecoilState(dialogState);
  const [confirmationDialog, setConfirmationDialogState] = useRecoilState(
    confirmationDialogState
  );
  // eslint-disable-next-line no-unused-vars
  const [handleError, setHandleError] = useRecoilState(handleErrorState);
  // eslint-disable-next-line no-unused-vars
  const [loadingOverlay, setLoadingOverlayState] =
    useRecoilState(loadingOverlayState);
  // eslint-disable-next-line no-unused-vars
  const [snackBar, setSnackBar] = useRecoilState(snackBarState);

  useEffect(() => {
    const url = `${settings().apiUrl}/api/buyings`;
    const headers = getHeaders();

    setData([    
      {
        id: '111111',
        view: '111111',
        name: 'Loja 1',
        initials: 'MCD-SP',
        legal_name: "Mc Donald's Morumbi",
        cnpj: "00.888/0001-22",
        user: 'Felipe Rangel',
        address: 'Rua Exemplo de Exemplo',
        number: '145',
        complement: 'bloco 2 sala 107',
        neighborhood: 'Barra da Tijuca',
        city: 'Rio de Janeiro',
        uf: 'RJ',
        zipcode: '22773-045',
        status: true,
      },
      {
        id: '2222222',
        view: '2222222',
        name: 'Loja 1',
        initials: 'MCD-SP',
        legal_name: "Mc Donald's Morumbi",
        cnpj: "00.888/0001-22",
        user: 'Felipe Rangel',
        address: 'Rua Exemplo de Exemplo',
        number: '145',
        complement: 'bloco 2 sala 107',
        neighborhood: 'Barra da Tijuca',
        city: 'Rio de Janeiro',
        uf: 'RJ',
        zipcode: '22773-045',
        status: true,
      },
      {
        id: '333333',
        view: '333333',
        name: 'Loja 1',
        initials: 'MCD-SP',
        legal_name: "Mc Donald's Morumbi",
        cnpj: "00.888/0001-22",
        user: 'Felipe Rangel',
        address: 'Rua Exemplo de Exemplo',
        number: '145',
        complement: 'bloco 2 sala 107',
        neighborhood: 'Barra da Tijuca',
        city: 'Rio de Janeiro',
        uf: 'RJ',
        zipcode: '22773-045',
        status: true,
      },
      {
        id: '444444444',
        view: '444444444',
        name: 'Loja 1',
        initials: 'MCD-SP',
        legal_name: "Mc Donald's Morumbi",
        cnpj: "00.888/0001-22",
        user: 'Felipe Rangel',
        address: 'Rua Exemplo de Exemplo',
        number: '145',
        complement: 'bloco 2 sala 107',
        neighborhood: 'Barra da Tijuca',
        city: 'Rio de Janeiro',
        uf: 'RJ',
        zipcode: '22773-045',
        status: false,
      },
    ]);
    setLoading(false);

    /*axios
      .get(url, { headers })
      .then((response) => {
        setData([...response.data.data]);
        setLoading(false);
      })
      .catch((error) =>
        setHandleError({ error: true, response: error.response })
      );*/
  }, []);


  const openEditDialog = (rowData: {}, indexKey: number) => {
    console.log('hey');
    setDialogState({
      ...dialog,
      open: true,
      title: "Editar Loja",
      content: editDialog,
      maxWidth: "xl",
      transition: "regular",
    })
  };

  const addDialog = <StoreAdd setData={setData} data={data} />;

  const deleteItem = async (id: number) => {
    setLoadingOverlayState(true);
    let url = `${settings().apiUrl}/api/buyings/${id}`;
    let headers = getHeaders();

    await axios
      .delete(url, { headers })
      .catch((error) =>
        setHandleError({ error: true, response: error.response })
      );

    url = `${settings().apiUrl}/api/buyings`;
    headers = getHeaders();

    axios
      .get(url, { headers })
      .then((response) => {
        setData([...response.data.data]);
        setLoadingOverlayState(false);
        setSnackBar({
          open: true,
          type: "success",
          message: locale.products.form.edit.success,
        });
      })
      .catch((error) =>
        setHandleError({ error: true, response: error.response })
      );
  };

  const editDialog = <StoreEdit />;

  const tableIndexes = locale.buyings.index.table;
  const columns = [
    {
      label: "ID",
      name: "id",
    },
    {
      label: "Cliente",
      name: "name",
    },
    {
      label: "Sigla",
      name: "initials",
    },
    {
      label: "Razão Social",
      name: "legal_name",
    },
    {
      label: "CNPJ",
      name: "cnpj",
    },
    {
      label: "Responsável",
      name: "user",
    },
    {
      label: "Endereço",
      name: "address",
    },
    {
      label: "Número",
      name: "number",
    },
    {
      label: "Complemento",
      name: "complement",
    },
    {
      label: "Bairro",
      name: "neighborhood",
    },
    {
      label: "Cidade",
      name: "city",
    },
    {
      label: "UF",
      name: "uf",
    },
    {
      label: "CEP",
      name: "zipcode",
    },
    {
      label: "Mudar Status",
      name: "status",
      options: {
        // eslint-disable-next-line no-unused-vars
        customBodyRender: (
          value: any,
          tableMeta: { rowIndex: number },
          // eslint-disable-next-line no-unused-vars
          updateValue: any
        ) => (

          <>
            {value === true && <CancelButton
                variant="contained"
                size="small"
                onClick={() =>
                  {return false;}
                }
              >
                <PowerSettingsNew style={{ fontSize: 18 }} />
              </CancelButton>}
            {value === false && <ConfirmButton
                variant="contained"
                size="small"
                onClick={() =>
                  {return false;}
                }
              >
                <PowerSettingsNew style={{ fontSize: 18 }} />
              </ConfirmButton>}
          </>         
        ),
      },
    },
    {
      label: " ",
      name: "id",
      options: {
        // eslint-disable-next-line no-unused-vars
        customBodyRender: (
          value: number,
          tableMeta: { rowIndex: number },
          // eslint-disable-next-line no-unused-vars
          updateValue: any
        ) => (
          <>
            <EditButton
              onClick={() =>
                openEditDialog(data[tableMeta.rowIndex], tableMeta.rowIndex)
              }
            />
          </>
        ),
      },
    },
  ];

  return (
    <>
      <ContentWrapper loading={loading}>
        <MainHeader
          title={<TitleHeader>{"Lista de Lojas"}</TitleHeader>}
          button={
            <AddButton
              onClick={() =>
                setDialogState({
                  ...dialog,
                  open: true,
                  title: "Cadastrar Nova Loja",
                  content: addDialog,
                  maxWidth: "xl",
                  transition: "regular",
                })
              }
            >
              {"Cadastrar Nova Loja"}
            </AddButton>
          }
        />
        <DividerWrapper />
        <MainTable data={data} columns={columns} />
      </ContentWrapper>
    </>
  );
};

export default Store;
